import { useTranslation } from '../i18n';
import { useIntake } from '../state/IntakeContext';
import { ThemeToggle } from './ThemeToggle';
import './SubmittedScreen.css';

export function SubmittedScreen() {
  const { t } = useTranslation();
  const { resetAll } = useIntake();

  return (
    <main id="main" className="cf-submitted-screen">
      <header className="cf-submitted-header">
        <ThemeToggle />
      </header>

      <section
        className="cf-submitted-card"
        role="status"
        aria-live="polite"
      >
        <div className="cf-submitted-icon" aria-hidden="true">
          ✓
        </div>
        <h1 className="cf-submitted-title">{t('submitted.title')}</h1>
        <p className="cf-submitted-body">{t('submitted.body')}</p>
        <button
          type="button"
          className="cf-btn cf-btn--ghost"
          onClick={resetAll}
        >
          {t('submitted.start_new')}
        </button>
      </section>
    </main>
  );
}
